import * as React from "react";
import { Button, ListGroup, ListGroupItem } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { EmptyPlaceholder, FlexLayout, Icon } from "../../../controls/api";
import * as util from "../../../util/api";
import { ComponentEx } from "../../../controls/ComponentEx";
import * as selectors from "../../../util/selectors";
import { genCollectionLoadOrder, isModInCollection, isValidMod } from "../util";
import { findGameEntry } from "../gameSupport";
import { currentGameMods, currentLoadOrderForProfile } from "../selectors";
const NAMESPACE = "generic-load-order-extension";
class LoadOrderCollections extends ComponentEx {
    static getDerivedStateFromProps(newProps, prevState) {
        const { mods, collection } = newProps;
        const filtered = newProps.loadOrder
            .filter((entry) => collection !== undefined
            ? isValidMod(mods[entry.modId]) &&
                isModInCollection(collection, mods[entry.modId])
            : isValidMod(mods[entry.modId]))
            .map((entry) => entry.modId);
        if (filtered !== prevState.filteredModIds) {
            return { filteredModIds: filtered };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.initState({
            loadOrder: [],
            filteredModIds: [],
        });
    }
    render() {
        const { t } = this.props;
        const { loadOrder } = this.state;
        return !!loadOrder && Object.keys(loadOrder).length !== 0 ? (React.createElement("div", { style: { overflow: "auto" } },
            React.createElement("h4", null, t("Load Order")),
            React.createElement("p", null, t("This is a snapshot of the load order information that " +
                "will be exported with this collection.")),
            this.renderLoadOrderEditInfo(),
            React.createElement(ListGroup, { id: "collections-load-order-list" }, loadOrder.map(this.renderModEntry)))) : (this.renderPlaceholder());
    }
    componentDidMount() {
        this.genLoadOrder();
    }
    componentDidUpdate(prevProps) {
        const currentRules = JSON.stringify(this.props.collection.rules);
        const prevRules = JSON.stringify(prevProps.collection.rules);
        const currentLO = JSON.stringify(this.props.loadOrder);
        const prevLO = JSON.stringify(prevProps.loadOrder);
        if (currentRules !== prevRules || currentLO !== prevLO) {
            this.genLoadOrder();
        }
    }
    async genLoadOrder() {
        try {
            const gameEntry = findGameEntry(this.props.gameId);
            this.nextState.loadOrder = await genCollectionLoadOrder(this.context.api, gameEntry, this.props.mods, this.props.profile.id, this.props.collection);
        }
        catch (err) {
            this.context.api.showErrorNotification("Failed to read load order", err, {
                allowReport: false,
            });
        }
    }
    renderLoadOrderEditInfo = () => {
        const { t } = this.props;
        return (React.createElement(FlexLayout, { type: "row", id: "collection-edit-loadorder-edit-info-container" },
            React.createElement(FlexLayout.Fixed, { className: "loadorder-edit-info-icon" },
                React.createElement(Icon, { name: "dialog-info" })),
            React.createElement(FlexLayout.Fixed, { className: "collection-edit-loadorder-edit-info" },
                t("You can make changes to this data from the "),
                React.createElement("a", { className: "fake-link", onClick: this.openLoadOrderPage, title: t("Go to Load Order Page") }, t("Load Order page.")),
                t(" If you believe a load order entry is missing, please ensure the " +
                    "relevant mod is enabled and has been added to the collection."),
                t(" Note that the game you've created this collection for relies on a load order " +
                    "file which the game extension creates when deploying your mods - to ensure that " +
                    "the correct load order is published alongside this collection, please remember to " +
                    "deploy your mods!"))));
    };
    openLoadOrderPage = () => {
        this.context.api.events.emit("show-main-page", "generic-loadorder");
    };
    renderOpenLOButton = () => {
        const { t } = this.props;
        return (React.createElement(Button, { id: "btn-more-mods", className: "collection-add-mods-btn", onClick: this.openLoadOrderPage, bsStyle: "ghost" }, t("Open Load Order Page")));
    };
    renderPlaceholder = () => {
        const { t } = this.props;
        return (React.createElement(EmptyPlaceholder, { icon: "sort-none", text: t("You have no load order entries (for the current mods in the collection)"), subtext: this.renderOpenLOButton() }));
    };
    renderModEntry = (loEntry) => {
        const { loadOrder } = this.state;
        const idx = loadOrder.indexOf(loEntry);
        const key = loEntry.id + JSON.stringify(loEntry);
        const name = loEntry.name || loEntry.modId !== undefined
            ? util.renderModName(this.props.mods[loEntry.modId])
            : loEntry.id;
        const classes = ["load-order-entry", "collection-tab"];
        return (React.createElement(ListGroupItem, { key: key, className: classes.join(" ") },
            React.createElement(FlexLayout, { type: "row" },
                React.createElement("p", { className: "load-order-index" }, idx),
                React.createElement("p", null, name))));
    };
}
function mapStateToProps(state, ownProps) {
    const profile = selectors.activeProfile(state);
    return {
        gameId: selectors.activeGameId(state),
        loadOrder: currentLoadOrderForProfile(state, profile.id),
        mods: currentGameMods(state),
        profile,
    };
}
export default withTranslation(["common", NAMESPACE])(connect(mapStateToProps, undefined)(LoadOrderCollections));
